import AutomationError from './AutomationError';
class InvestorHasInvalidFiscalRegime extends AutomationError {
    constructor(options) {
        super('The investor’s fiscal regime is not valid.', options);
    }
}
export default InvestorHasInvalidFiscalRegime;
